import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'Reporting|Banned Candidates|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPReportingBannedCandidates';
export type SPReportingBannedCandidatesLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}LabelCmcId`
	| `${LocNameStart}LabelLogin`
	| `${LocNameStart}LabelFirstName`
	| `${LocNameStart}LabelLastName`
	| `${LocNameStart}LabelBannedUntil`;

export const spReportingBannedCandidatesLocs: LocDefs<SPReportingBannedCandidatesLocNames> = {
	SPReportingBannedCandidatesTitlePage: {
		defaultValue: 'Banned Candidates Report',
		description: 'Page Title',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'Core/Reporting.BannedCandidates.Title.PageTitle',
		...sharedProperties,
	},
	SPReportingBannedCandidatesTitleTab: {
		defaultValue: 'Banned Candidates Report',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'Core/Reporting.BannedCandidates.Title.TabTitle',
		...sharedProperties,
	},
	SPReportingBannedCandidatesTitleSection: {
		defaultValue: 'Banned Candidates',
		description: 'Section Title',
		displayPath: `${pathStart}Section Title`,
		displayType: 'Title',
		legacyName: 'Core/Reporting.BannedCandidates.Title.SectionTitle',
		...sharedProperties,
	},
	SPReportingBannedCandidatesLabelCmcId: {
		defaultValue: 'CMC ID',
		description: 'Column heading for: CMC ID.',
		displayPath: `${pathStart}CMC ID`,
		displayType: 'Label',
		legacyName: 'Core/Reporting.BannedCandidates.ColumnHeading.CmcId',
		...sharedProperties,
	},
	SPReportingBannedCandidatesLabelLogin: {
		defaultValue: 'Login',
		description: 'Column heading for: Login.',
		displayPath: `${pathStart}Login`,
		displayType: 'Label',
		legacyName: 'Core/Reporting.BannedCandidates.ColumnHeading.Login',
		...sharedProperties,
	},
	SPReportingBannedCandidatesLabelFirstName: {
		defaultValue: 'First Name',
		description: 'Column heading for: First Name.',
		displayPath: `${pathStart}First Name`,
		displayType: 'Label',
		legacyName: 'Core/Reporting.BannedCandidates.ColumnHeading.FirstName',
		...sharedProperties,
	},
	SPReportingBannedCandidatesLabelLastName: {
		defaultValue: 'Last Name',
		description: 'Column heading for: Last Name.',
		displayPath: `${pathStart}Last Name`,
		displayType: 'Label',
		legacyName: 'Core/Reporting.BannedCandidates.ColumnHeading.LastName',
		...sharedProperties,
	},
	SPReportingBannedCandidatesLabelBannedUntil: {
		defaultValue: 'Banned Until',
		description: 'Column heading for: Banned Until.',
		displayPath: `${pathStart}Banned Until`,
		displayType: 'Label',
		legacyName: 'Core/Reporting.BannedCandidates.ColumnHeading.BannedUntil',
		...sharedProperties,
	},
};

export type SPReportingBannedCandidatesLocType = LocMap<SPReportingBannedCandidatesLocNames>;
